import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import * as _ from 'lodash';
import { TranslateModule } from '@ngx-translate/core';
import { CollapseItemDirective, CollapseContentDirective } from '../../../shared/directives/collapse.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-range-input',
    templateUrl: './range-input.component.html',
    styleUrls: ['./range-input.component.scss'],
    standalone: true,
    imports: [NgIf, CdkOverlayOrigin, MatIconModule, CdkConnectedOverlay, MatInputModule, FormsModule, ReactiveFormsModule, CollapseItemDirective, CollapseContentDirective, TranslateModule]
})
export class RangeInputComponent implements OnInit {

    constructor(public translateHelper: TranslateHelper
    ) { }
    @Input() icon = '';
    @Input() label = '';
    @Input() customLabel = '';
    @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline'| 'filter' = 'outline';
    @Input() placeholder = '';
    @Input() minControl;
    @Input() maxControl;

    @ViewChild("btnRef", { static: false }) btn;
    @ViewChild("btnIconRef", { static: false }) btnIcon;
    @ViewChild("btnLabelRef", { static: false }) btnLabel;

    ngOnInit(): void {
    }

    isOpen = false;

    menuClickOutside(event) {
        if (event.srcElement == this.btn?.nativeElement || event.srcElement == this.btnIcon?._elementRef?.nativeElement || event.srcElement == this.btnLabel?.nativeElement) {
            this.isOpen = false;
            event.preventDefault();
            event.stopPropagation();
        } else {
            let found = false;
            _.forEach(this.btnLabel?.nativeElement.children, child => {
                if (child == event.srcElement) {
                    found = true;
                    return false;
                }
            })
            this.isOpen = false;
            if (found) {
                event.preventDefault();
                event.stopPropagation();

            }

        }
    }

    toggleTrigger(evt) {
        this.isOpen = !this.isOpen;
        evt.preventDefault();
        evt.stopPropagation();
    }


}
